var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotaku(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 44.5 30.5",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70432 29.4202L12.9121 29.2959C16.4506 29.1603 19.6986 26.4872 20.2157 23.3634L23.8268 1.79465L14.8161 1.53915L9.70432 29.4202ZM32.785 11.4572C35.907 11.4712 37.1162 12.5789 37.972 14.3158L43.9526 29.049C42.4432 30.3983 35.3899 29.9302 33.3879 24.639L31.2065 18.7564L30.6657 18.7652L30.1967 18.7678C26.863 18.8159 22.1415 16.3292 23.1617 11.4152L32.785 11.4572ZM13.3522 1.49532L8.46616 1.35707C1.65866 1.16282 -0.219088 5.98582 0.342662 9.12707L11.9478 9.23732L13.3522 1.49532ZM40.9671 8.22323C43.2543 6.77073 44.2343 1.53473 42.6243 0.000854492L30.8031 2.9706C28.7888 4.0906 26.4806 7.36135 28.7696 10.9769L40.9671 8.22323Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotaku);
export default __webpack_public_path__ + "static/media/kotaku.069e9d5efdc1e0b27150bf14adf22b86.svg";
export { ForwardRef as ReactComponent };